<header class="header-wrapper">
  <div>
    <div class="nav-part start">
      <div class="logo">
        <a [routerLink]="'/'"><img [src]="logoImg" alt="siemens logo" /></a>
      </div>
      <div class="app-name">{{ 'header.toolTitle' | translate }} 4.1</div>
    </div>

    <!-- Desktop Navigation -->
    @if (!isMobile()) {
      <div class="nav-part end">
        <a class="nav-icon service-desk-link" [href]="serviceDeskLink" [matTooltip]="'default.support' | translate" target="_blank">
          <span class="icon-Support"></span>
        </a>
        <button class="nav-icon notification-button" [matTooltip]="'navigation.notifications' | translate" (click)="openNotificationsSidebar()">
          <span class="icon-Notification"></span>
          @if (notificationCount() > 0) {
            <span class="notification-badge">{{ notificationCount() > 99 ? '99+' : notificationCount() }}</span>
          }
        </button>
        <button class="nav-icon" [matTooltip]="'navigation.news' | translate" (click)="openNewsSidebar()">
          <span class="icon-Document"></span>
        </button>
        <button class="nav-icon" [matMenuTriggerFor]="langMenu">
          <span class="icon-Language"></span>
        </button>
        <mat-menu #langMenu="matMenu">
          <button (click)="changeLang('en')" mat-menu-item>English</button>
          <button (click)="changeLang('de')" mat-menu-item>Deutsch</button>
        </mat-menu>

        <button class="nav-icon" [matMenuTriggerFor]="settingsMenu">
          <span class="icon-Settings"></span>
        </button>
        <mat-menu #settingsMenu="matMenu">
          <button [matMenuTriggerFor]="themeMenu" mat-menu-item>{{ 'header.theme' | translate }}</button>
          @if ((userRole$ | async) !== USER_ROLES.ONLINE_SUPPORT) {
            <button (click)="openApplicationFilterDialog()" mat-menu-item>{{ 'header.applicationFilter' | translate }}</button>
            <button (click)="openTimesheetSettingsDialog()" mat-menu-item>{{ 'header.timesheetSettings' | translate }}</button>
            <button (click)="navigateToPersonalInformationPage()" mat-menu-item>{{ 'header.personalInformation' | translate }}</button>
          }
          @if (
            (userRole$ | async) === USER_ROLES.TECHNISCHER_CONTROLLER ||
            (userRole$ | async) === USER_ROLES.BUDGETVERANTWORTLICHER ||
            (userRole$ | async) === USER_ROLES.GRUPPENLEITER
          ) {
            <button (click)="openCreateNewsDialog()" mat-menu-item>{{ 'header.createNews' | translate }}</button>
          }
          <button (click)="navigateToReleaseNotesPage()" mat-menu-item>{{ 'header.releaseNotes' | translate }}</button>
          @if ((userRole$ | async) !== USER_ROLES.ONLINE_SUPPORT) {
            <button [matMenuTriggerFor]="impersonationMenu" mat-menu-item>
              {{ 'header.userSettings.impersonation.impersonation' | translate }}
            </button>
          }
        </mat-menu>
        <mat-menu #themeMenu="matMenu">
          <button (click)="setTheme('light')" mat-menu-item>
            {{ 'header.light' | translate }}
          </button>
          <button (click)="setTheme('dark')" mat-menu-item>
            {{ 'header.dark' | translate }}
          </button>
        </mat-menu>
        <mat-menu #impersonationMenu="matMenu">
          @if (!isImpersonating()) {
            <button (click)="openSelectImpersonationDialog()" mat-menu-item>
              {{ 'header.userSettings.impersonation.impersonate' | translate }}
            </button>
            <button (click)="openEditImpersonationDialog()" mat-menu-item>
              {{ 'header.userSettings.impersonation.editImpersonation' | translate }}
            </button>
          } @else {
            <button (click)="stopImpersonation()" mat-menu-item>
              {{ 'header.userSettings.impersonation.stopImpersonation' | translate }}
            </button>
          }
        </mat-menu>

        <app-user></app-user>
      </div>
    }

    <!-- Mobile Menu Toggle -->
    @if (isMobile()) {
      <div class="nav-part end">
        <div class="nav-icon" (click)="toggleSidebar()">
          <span class="icon-Menu"></span>
        </div>
      </div>
    }
  </div>
  @if (isMobile()) {
    <div class="current-page-title">{{ currentPageTitle }}</div>
  }

  <!-- Desktop Navigation Links -->
  @if (!isMobile()) {
    <div>
      <nav class="nav-items nav-part start">
        @for (navItem of navItems; track navItem) {
          <a
            class="nav-item"
            [routerLink]="navItem.route"
            [attr.data-testid]="navItem.route === '/timesheets' ? 'header-timesheets-link' : null"
            routerLinkActive="active"
            >{{ navItem.transKey | translate }}</a
          >
        }
      </nav>
      <div class="nav-links nav-part start">
        <a class="nav-link" [href]="reportingLink" target="_blank">{{ 'navigation.reporting' | translate }}</a>
        <span class="icon icon-Link-extern"></span>
      </div>
    </div>
  }
</header>
